import { Route } from 'vue-router'

export const savePreviousRoute = async (to: Route) => {
  if (!to.path.includes('login')) localStorage.setItem('previousRoute', to.path)
}
